import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretLeft, faSave, faCaretRight, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import $ from 'jquery';
import moment from 'moment';
import Axios from 'axios';
import {Alert, Logout, BaseURL, DConnect, DecryptData, PostOptions} from '../../components/Config'

function OwnerDetails(props){
    const [registration, setRegistration] = useState(props.registration);
    const [position, setPosition] = useState(props.position);
    const [businessDetails, setBusinessDetails] = useState(props.businessDetails);
    const [ownerDetails, setOwnerdetails] = useState (props.ownerDetails);
    const [curdistrict, setCurdistrict] = useState([]);
    const [gpsValid1, setGPSValid1] = useState('');
    const [save, setSave] = useState(false);
    const [gpsValid2, setGPSValid2] = useState('');
    const [dropdowns, setDropdowns] = useState({'idtype':[],'gender':[], 'regions':[],'districts':[], 'age_bracket':[]});
    const [image, setImage] = useState({cert:'', imageUrl:'', ex:''});

    useEffect(() => {
        setRegistration(props.registration);
        props.getProps(props);
        if(ownerDetails.firstname == ''){
            ownerDetails.firstname=props.registration.firstname;
            ownerDetails.othernames=props.registration.midname;
            ownerDetails.lastname=props.registration.lastname;
            ownerDetails.idtype=props.registration.idtype;
            ownerDetails.idno=props.registration.idno;
        }
        setOwnerdetails(props.ownerDetails);
        setBusinessDetails(props.businessDetails);
        setDropdowns(props.dropdowns);
        setRegistration(props.registration);
        if(props.ownerDetails.id == 0){
            getOwnerDetails();
        }

        if(props.ownerDetails.region!=='' && props.dropdowns.districts !== undefined){
            setCurdistrict(props.dropdowns.districts.filter(dist => dist.region === props.ownerDetails.region));
        }


        $('#ownerCertCon').on('click tap', function(e){
            e.preventDefault();
            $('#idimage').click();
        });
    }, [props.ownerDetails]);

    const filterDistrict = (region) => setCurdistrict(dropdowns.districts.filter(dist => dist.region === region));

    const getOwnerDetails = () => {
            let resdata = ownerDetails;
            if(resdata.region !== undefined){
                setCurdistrict(props.dropdowns.districts !== undefined ? props.dropdowns.districts.filter(dist => dist.region === resdata.region): []);
            }
    }

    const validateGPS = (field) => {
        let owndetail = ownerDetails
        if(owndetail[field] != null && (owndetail[field].length  == 11 || owndetail[field].length  == 12 || owndetail[field].length  == 13)){
           
            if(owndetail[field].charAt(2) == '-' && (owndetail[field].charAt(6) == '-' || owndetail[field].charAt(7) == '-' || owndetail[field].charAt(8) == '-')){
                if((/[a-zA-Z0-9]/).test(owndetail[field].charAt(0)) && (/[a-zA-Z0-9]/).test(owndetail[field].charAt(1))){
                    if((((/^\d+$/).test(owndetail[field].substr(3, 3)) && owndetail[field].substr(3, 3).length == 3) && ((/^\d+$/).test(owndetail[field].substr(7, 10)) && owndetail[field].substr(7, 10).length == 4)) ||
                    (((/^\d+$/).test(owndetail[field].substr(3, 4)) && owndetail[field].substr(3, 4).length == 4) && (((/^\d+$/).test(owndetail[field].substr(8, 11)) && owndetail[field].substr(8, 11).length == 4) || ((/^\d+$/).test(owndetail[field].substr(8, 12)) && owndetail[field].substr(8, 12).length == 5))) ||
                    (((/^\d+$/).test(owndetail[field].substr(3, 5)) && owndetail[field].substr(3, 5).length == 5) && ((/^\d+$/).test(owndetail[field].substr(9, 12)) && owndetail[field].substr(9, 12).length == 4))){
                        if(field == 'gps'){
                        setGPSValid1('');
                        }else{
                            setGPSValid2(''); 
                        }
                    }else{
                        if(field == 'gps'){
                            setGPSValid1('Invalid GPS Address');
                            }else{
                                setGPSValid2('Invalid GPS Address');
                            }
                        setOwnerdetails(prevState => ({ ...prevState, [field]: '' }));
                    }
                }else{
                    if(field == 'gps'){
                        setGPSValid1('Invalid GPS Address');
                        }else{
                            setGPSValid2('Invalid GPS Address');
                        }
                    setOwnerdetails(prevState => ({ ...prevState, [field]: '' }));
                }
            }else{
                if(field == 'gps'){
                    setGPSValid1('Invalid GPS Address');
                    }else{
                        setGPSValid2('Invalid GPS Address');
                    }
                setOwnerdetails(prevState => ({ ...prevState, [field]: '' }));
            } 
        }else{
            if(field == 'gps'){
                setGPSValid1('Invalid GPS Address');
                }else{
                    setGPSValid2('Invalid GPS Address');
                }
            setOwnerdetails(prevState => ({ ...prevState, [field]: '' }));
        }

    }

    const handleChange = (e) => {
        const {name, value} = e.target;
        if(name === 'region'){
            filterDistrict(value);
        }

        if ((value.length === 1 && value == ' ') || (value.length > 1 && value.charAt(0) == ' ')) return;

        if(name === 'birth_date'){
            let age_bracket = 0; 
            let age = moment().diff(value, 'years');
            if(age >= 0 && age < 18){
                age_bracket = 1;
            }else if(age >= 18 && age <= 35){
                age_bracket = 2;
            }else if(age >= 36 && age <= 45){
                age_bracket = 3;
            }else if(age >= 46){
                age_bracket = 4;
            }
            setOwnerdetails(prevState => ({
                ...prevState, ['age_bracket']:age_bracket
            }));
        }
     if(['firstname','lastname','othernames'].includes(name) && value.length > 0){
        var letters = /^[A-Za-z]+$/;
        if(!value.match(letters)) return;
     }else if(['lastname'].includes(name) && value.length > 0){
        var lettershyphen = /^[A-Za-z-]+$/;
        if(!value.match(lettershyphen)) return;
     }
    //  else if(['landmark'].includes(name) && value.length > 0){
    //      let alphanumeric = /^[a-zA-Z0-9]+$/;
    //      if(!value.match(alphanumeric)) return;
    //  }
     else if(['landmark'].includes(name) && value.length > 0){
        let alphanumericspace = /^[a-zA-Z0-9 ]+$/;
        if(!value.match(alphanumericspace)) return;
    }else if(['rep_phone','mobile','phone'].includes(name) && value.length > 0){
        let numeric = /^[0-9]+$/;
        if(!value.match(numeric)) return;
    }else if(['town','disability_type','rep_name','rep_title'].includes(name) && value.length > 0){
        let alphaspace = /^[a-zA-Z ]*$/;
        if(!value.match(alphaspace)) return;
    }  
        setOwnerdetails(prevState => ({
            ...prevState, [name]:value
            
        }));
          
    }

    const imageChange = (e) => {
        e.preventDefault();

        let reader = new FileReader();
        let file = e.target.files[0];
        let ext = file.name.split('.');
        if(['jpg','jpeg','png'].includes(ext[ext.length-1])){
        setOwnerdetails(prevState => ({...prevState, ['idimage']:`${businessDetails.app_num}_id.${ext[ext.length-1]}`}));

        reader.onloadend = () => {
            let image = {cert:file, imageUrl: reader.result, ext:ext[ext.length-1]};
            setImage(image);
        }

        reader.readAsDataURL(file);
      }else{
          alert("Unacceptable file type. Please try again...")
      }
    }

    const submitForm = (e) => {
        e.preventDefault();

        props.handleChange(6, ownerDetails);
        if(ownerDetails.id == 0){
            ownerDetails.app_num = businessDetails.app_num;
        }
        
        let options = (ownerDetails.id == 0) ? PostOptions('POST', ownerDetails, 'owner')
        : PostOptions('PUT', ownerDetails, `owner/${ownerDetails.id}`);
        
        Axios(options).then(res => {
            let resdata = DecryptData(res.data);

            //Process File Upload
            let formData = new FormData();
            formData.append('filename', ownerDetails.idimage);
            formData.append('cert', image.cert);
            Axios.post(`${BaseURL()}v1.0/fileupload`, formData).then(resp => {});

            if(resdata.id !== undefined){
                ownerDetails['id'] = resdata.id;
                props.handleChange(6, ownerDetails);
            }

            position.app_num = registration.app_num;
            position.ma_stage = position.ma_stage < 5 ? 5: position.ma_stage;
            props.handleChange(14, position);
            options = (position.id == 0) ? PostOptions('POST', position, 'appstage')
            : PostOptions('PUT', position, `appstage/${position.id}`);
            Axios(options).then(resD => {
                let resData = DecryptData(resD.data); 

                if (resData.id !== undefined) {
                    position['id'] = resData.id;
                    props.handleChange(14, position);
                }
                })
        })//.catch(error => {Alert({title:'Owner Details',message:error.message, buttons:[{label:'Ok'}]});});
        if(save){
        Logout()
        window.location.reload()
        }else{
        props.doNavigate(props,5,1);
        }
    }

    return(
        <div className="content">
            <h5>Owner <span>Details</span></h5><br />
            <form id="frmOwnerDetails" method="POST" onSubmit={submitForm}>
                    <div className="row">
                        <div className="col-xs-12 col-md-6 ">
                            <div className="form-group">
                                <label for="firstname">First Name:</label><span className="required">*</span>
                                <input type="text" className="form-control" id="firstname" name="firstname" required="required"
                                value={ownerDetails.firstname} onChange={handleChange} />
                            </div>
                            <div className="form-group">
                                <label for="lastname">Last Name:</label><span className="required">*</span>
                                <input type="text" className="form-control" id="lastname" name="lastname" required="required"
                                value={ownerDetails.lastname} onChange={handleChange} />
                            </div>
                            <div className="form-group">
                                <label for="othernames">Other Names:</label>
                                <input type="text" className="form-control" id="othernames" name="othernames"
                                value={ownerDetails.othernames} onChange={handleChange} />
                            </div>
                            <div className="form-group">
                                <label for="disability">Is the business/enterprise owner a person with disability?: <span className="required">*</span></label>
                                <select className="form-control custom-select" id="disability" name="disability" required="required"
                                    value={ownerDetails.disability} onChange={handleChange}>
                                    <option value={0}>No</option>
                                    <option value={1}>Yes</option>
                                </select>
                            </div>
                            {ownerDetails.disability == 1 && <div className="form-group">
                                <label for="disability_type">Please specify type of disability:</label>
                                <input type="text" className="form-control" id="disability_type" name="disability_type"
                                value={ownerDetails.disability_type} onChange={handleChange} />
                            </div>} 
                            <div className="form-group">
                                <label className="control-label" for="female_dominated">Is Your Business Female-Majority Owned?</label><span className="required">*</span>
                                <select className="form-control custom-select" id="female_dominated" name="female_dominated" required="required" 
                                    value={ownerDetails.female_dominated} onChange={handleChange}>
                                    <option value=""> -- Choose Option -- </option>
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                            </div>
                            
                            <div className="form-group">
                                <label for="town">Town:</label><span className="required">*</span>
                                <input type="text" className="form-control" id="town" name="town" required="required"
                                value={ownerDetails.town} onChange={handleChange} />
                            </div>
                            <div className="form-group">
                                <label className="control-label" for="region">Region: </label><span className="required">*</span>
                                <select className="form-control custom-select" id="region" name="region" required
                                    value={ownerDetails.region} onChange={handleChange}>
                                    <option value=""> -- Choose Region -- </option>
                                    {dropdowns.regions.map(region => (
                                        <option value={region.code}>{region.name} ({region.code})</option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label className="control-label" for="district">District:</label><span className="required">*</span>
                                <select className="form-control custom-select" id="district" name="district" required="required" 
                                    value={ownerDetails.district} onChange={handleChange}>
                                    <option value=""> -- Choose District -- </option>
                                    {curdistrict.map(curd => (
                                        <option value={curd.id}>{curd.name} ({curd.code})</option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Is the person completing this form same as the <b>Business Owner</b>?</label>
                                <div className="form-check">
                                    <div className="row pb-3">
                                        <div className="col-1"><input type="radio" name="isapplicant_owner" id="isapplicant_ownerno" className="form-check-input form-control" style={{height:'20px'}} value={0} checked={ownerDetails.isapplicant_owner ==0} onChange={handleChange} /></div>
                                        <div className="col-2"><label className="form-check-label" for="isapplicant_ownerno" style={{lineHeight:'20px'}}> No</label></div>
                                        <div className="col-1"><input type="radio" name="isapplicant_owner" id="isapplicant_owneryes" className="form-check-input form-control" style={{height:'20px'}} value={1} checked={ownerDetails.isapplicant_owner ==1} onChange={handleChange} /></div>
                                        <div className="col-2"><label className="form-check-label" for="isapplicant_owneryes" style={{lineHeight:'20px'}}> Yes</label></div>
                                    </div>
                                </div>
                            </div>
                            {ownerDetails.isapplicant_owner == 0 && <>
                                
                            <div className="form-group">
                                <label for="rep_name">Rep Full Name:</label><span className="required">*</span>
                                <input type="text" className="form-control" id="rep_name" name="rep_name"
                                value={ownerDetails.rep_name} onChange={handleChange} required />
                            </div>
                            <div className="form-group">
                                <label for="rep_title">Rep Title:</label><span className="required">*</span>
                                <input type="text" className="form-control" id="rep_title" name="rep_title"
                                value={ownerDetails.rep_title}  onChange={handleChange} required />
                            </div>
                            <div className="form-group">
                                <label for="rep_phone">Rep Phone Number:</label><span className="required">*</span>
                                <input type="text" className="form-control" id="rep_phone" name="rep_phone"
                                value={ownerDetails.rep_phone} onChange={handleChange} required />
                            </div><div className="form-group">
                                <label for="rep_email">Rep Email Address:</label><span className="required">*</span>
                                <input type="email" className="form-control" id="rep_email" name="rep_email"
                                value={ownerDetails.rep_email} onChange={handleChange} required />
                            </div>
                            <div className="form-group">
                            <label for="rep_gps">Rep GPS:</label><span className="required">*</span>
                            <input type="text" className="form-control" id="rep_gps" name="rep_gps"  required="required"
                            value={ownerDetails.rep_gps} onChange={handleChange} onBlur={() => validateGPS('rep_gps')} maxLength="13"/>
                            <small className="text-danger">{gpsValid2}</small>
                        </div>
                            <div className="form-group">
                            <label for="rep_address_res">Rep Residential Address:</label><span className="required">*</span>
                            <textarea className="form-control" rows="5" id="rep_address_res" name="rep_address_res" required="required" 
                            value={ownerDetails.rep_address_res} onChange={handleChange} />
                            </div>
                            <div className="form-group">
                                <label for="rep_idtype">Rep ID Type:</label><span className="required">*</span>
                                <select className="form-control custom-select" id="rep_idtype" name="rep_idtype" required="required"
                                value={ownerDetails.rep_idtype} onChange={handleChange}>
                                    <option value=""> -- Choose ID Type -- </option>
                                    {dropdowns.idtype.map(idt => (
                                        <option value={idt.ivalue}>{idt.iname}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label for="rep_idno">Rep ID Number:</label><span className="required">*</span>
                                <input type="text" className="form-control" id="rep_idno" name="rep_idno" required="required"
                                value={ownerDetails.rep_idno} onChange={handleChange} readOnly />
                            </div>
                            </>}
                           
                        </div>
                        <div className="col-xs-12 col-md-6">
                        <div className="form-group">
                                <label for="birth_date">Date of Birth:</label><span className="required">*</span>
                                <input type="date" className="form-control" id="birth_date" name="birth_date" required="required"
                                value={ownerDetails.birth_date} max={new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString().split("T")[0]} onChange={handleChange} />
                            </div>
                            <div className="form-group">
                                <label for="age_bracket">Age Bracket:</label><span className="required">*</span>
                                <select className="form-control custom-select" id="age_bracket" name="age_bracket" required="required"
                                value={ownerDetails.age_bracket} disabled>
                                     <option value=""> -- Choose status -- </option>
                                     {dropdowns.age_bracket.map(mstatus => (
                                        <option value={mstatus.ivalue}>{mstatus.iname}</option>
                                    ))}
                                </select>
                            </div>   
                        <div className="form-group">
                                <label for="address_res">Residential Address:</label><span className="required">*</span>
                                <textarea className="form-control" rows="5" id="address_res" name="address_res" required="required" 
                                value={ownerDetails.address_res} onChange={handleChange} />
                            </div>
                            <div className="form-group">
                                <label for="address_postal">Postal Address:</label><span className="required"></span>
                                <textarea className="form-control" rows="5" id="address_postal" name="address_postal"   
                                value={ownerDetails.address_postal} onChange={handleChange} />
                            </div>
                            <div className="form-group">
                                <label for="gps">GPS Address:</label><span className="required">*</span>
                                <input type="text" className="form-control" id="gps" name="gps" required="required" 
                                value={ownerDetails.gps} onChange={handleChange} onBlur={() => validateGPS('gps')} maxLength="13"/>
                                <small className="text-danger">{gpsValid1}</small>
                            </div>
                            <div className="form-group">
                                <label for="landmark">Nearest Landmark:</label><span className="required">*</span>
                                <input type="text" className="form-control" id="landmark" name="landmark"  
                                value={ownerDetails.landmark} onChange={handleChange} required="required" />
                            </div>
                            <div className="form-group">
                                <label for="mobile">Phone 1:</label><span className="required">*</span>
                                <input type="tel" className="form-control" id="mobile" name="mobile" pattern="[0-9]{10}" title="10 Digits, no alphabets allowed" minLength="0" maxLength="10"  
                                value={ownerDetails.mobile} onChange={handleChange} required="required"/>
                            </div>
                            <div className="form-group">
                                <label for="phone">Phone 2:</label>
                                <input type="tel" className="form-control" id="phone" name="phone" pattern="[0-9]{10}" title="10 Digits, no alphabets allowed" minLength="0" maxLength="10"  
                                value={ownerDetails.phone} onChange={handleChange}/>
                            </div>
                            <div className="form-group">
                                <label for="address_email">Email Address:</label><span className="required"></span>
                                <input type="email" className="form-control" id="address_email" name="address_email"  
                                value={ownerDetails.address_email} onChange={handleChange} />
                            </div>
                            <div className="form-group">
                                <label for="idtype">ID Type:</label><span className="required">*</span>
                                <select className="form-control custom-select" id="idtype" name="idtype" required="required"
                                value={ownerDetails.idtype} onChange={handleChange}>
                                    <option value=""> -- Choose ID Type -- </option>
                                    {dropdowns.idtype.map(idt => (
                                        <option value={idt.ivalue}>{idt.iname}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label for="idno">ID Number:</label><span className="required">*</span>
                                <input type="text" className="form-control" id="idno" name="idno" required="required"
                                value={ownerDetails.idno} onChange={handleChange} readOnly />
                            </div>
                            <div className="form-group">
                                <label for="idimage">Upload ID:</label>
                                <br /> <small className="text-primary">You can upload only images(JPG, JPEG, PNG)</small>
                                <div id="ownerCertCon" className="border border-primary text-center p-1" style={{cursor:'pointer',minHeight:'120px'}}>
                                    {ownerDetails.idimage == '' ? 'Click here to add' : 
                                    (![undefined,null].includes(ownerDetails.idimage) && (ownerDetails.idimage).includes('pdf')) 
                                    ? <FontAwesomeIcon icon={faFilePdf} style={{fontSize:'120px'}} />
                                    : <img src={(image.imageUrl !== '') ? image.imageUrl : `${BaseURL()}static/${ownerDetails.idimage}`} style={{height:'120px'}} /> }
                                </div>
                                <input type="file" className="form-control" accept=".jpg, .jpeg, .png" id="idimage" name="cert" style={{display:'none'}} 
                                onChange={imageChange} />
                            </div>
                            <div className="form-group">
                                <label for="gender">Gender:</label><span className="required">*</span>
                                <select className="form-control custom-select" id="gender" name="gender" required="required"
                                value={ownerDetails.gender} onChange={handleChange}>
                                    <option value=""> -- Choose Gender -- </option>
                                    {dropdowns.gender.map(gend => (
                                        <option value={gend.ivalue}>{gend.iname}</option>
                                    ))}
                                </select>
                            </div>
                                 
                    </div>
                        
                </div>
            </form>
            <button className="btn btn-bg btn-outline text-white" style={{padding:'10px 20px',borderRadius: '20px', marginTop: '25px'}} onClick={() => props.doNavigate(props,3,0)}><FontAwesomeIcon icon={faCaretLeft} size="lg" /> &nbsp; Go Back </button>
            <button type="submit" form="frmOwnerDetails"  className="btn btn-bg btn-outline text-white float-right" style={{padding:'10px 20px',borderBottomRightRadius: '20px', borderTopRightRadius: '20px', marginTop: '25px'}}>Save &amp; Next &nbsp;<FontAwesomeIcon icon={faCaretRight} size="lg"  /></button>
            <button type="submit" form="frmOwnerDetails" onClick={()=>setSave(true)} className="btn btn-bg btn-outline text-white float-right" style={{ padding: '10px 20px', borderBottomLeftRadius: '20px', borderTopLeftRadius: '20px', marginRight: '5px', marginTop: '25px' }}>Save &amp; Close &nbsp; <FontAwesomeIcon icon={faSave} size="lg" /></button>
        </div>
    )
}

export default OwnerDetails;